import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { newsEntriesPut, NewsEntryParam } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditNewsEntry = (
  id: number,
  options: UseMutationOptions<void, unknown, NewsEntryParam, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: NewsEntryParam) =>
      extractData(newsEntriesPut({ path: { id }, body: values })),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['newsEntries', id],
      });
      options.onSuccess?.(...args);
    },
  });
};
